import { PDFName, } from '..';
var PDFBlock = /** @class */ (function () {
    function PDFBlock(dict, name, pageIndex) {
        this.dict = dict;
        this.name = name;
        this.pageIndex = pageIndex;
    }
    PDFBlock.prototype.lookup = function (key) {
        return this.dict.lookup(key);
    };
    PDFBlock.prototype.isRectangleBlock = function () {
        return Boolean(this.getRect() && this.getType() === 'Block');
    };
    PDFBlock.prototype.getName = function () {
        return this.name;
    };
    PDFBlock.prototype.getPageIndex = function () {
        return this.pageIndex;
    };
    PDFBlock.prototype.getType = function () {
        var _a;
        return (_a = this.lookup(PDFName.of('Type'))) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFBlock.prototype.getRect = function () {
        var rectObj = this.lookup(PDFName.of('Rect'));
        return rectObj
            .asArray()
            .map(function (value) { return value.asNumber(); });
    };
    PDFBlock.prototype.getId = function () {
        var _a;
        return (_a = this.lookup(PDFName.of('ID'))) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFBlock.prototype.getSubType = function () {
        var _a;
        return (_a = this.lookup(PDFName.of('Subtype'))) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFBlock.prototype.getFontSize = function () {
        var _a;
        return (_a = this.lookup(PDFName.of('fontsize'))) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFBlock.prototype.getFontName = function () {
        var _a;
        return (_a = this.lookup(PDFName.of('fontname'))) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFBlock.prototype.getX = function () {
        return this.getRect()[0];
    };
    PDFBlock.prototype.getY = function () {
        return this.getRect()[1] + this.getHeight();
    };
    PDFBlock.prototype.getPaddingPosition = function () {
        var positionObj = this.lookup(PDFName.of('position'));
        return this._getPaddingPosition(positionObj);
    };
    PDFBlock.prototype.getSize = function () {
        var _a = this.getRect(), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        var width = Math.abs(x2 - x1);
        var height = Math.abs(y2 - y1);
        return { width: width, height: height };
    };
    PDFBlock.prototype.getWidth = function () {
        return this.getSize().width;
    };
    PDFBlock.prototype.getHeight = function () {
        return this.getSize().height;
    };
    PDFBlock.prototype._getPaddingPosition = function (positionObj) {
        if (positionObj && positionObj.asArray().length === 2) {
            return positionObj
                .asArray()
                .map(function (p) { return p.asNumber(); });
        }
        if (positionObj && positionObj.asArray().length === 1) {
            var x = positionObj.asArray()[0].asNumber();
            var y = x;
            return [x, y];
        }
        return [0, 0];
    };
    return PDFBlock;
}());
export default PDFBlock;
//# sourceMappingURL=PDFBlock.js.map